export default __webpack_public_path__ + "static/media/ANIMATOR_ODSZEDL.314e2f0c.png";